import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueResource from 'vue-resource'
import VeeValidate from 'vee-validate'
import VueX from 'vuex'
import Toasted from 'vue-toasted'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faFacebookF, faTwitter, faMediumM, faYoutube, faInstagram } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import initStore from './store/index'

Vue.use(VeeValidate, {
  delay: 1000
})
Vue.use(VueResource)
Vue.use(VueX)
Vue.use(Toasted, {
  position: 'bottom-right',
  duration: 3500,
  theme: 'outline',
})
library.add(faFacebookF, faTwitter, faMediumM, faYoutube, faInstagram)
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.http.options.root = process.env.VUE_APP_SERVICE_URL // eslint-disable-line
Vue.http.options.credentials = true

new Vue({
  router,
  store: initStore(),
  el: "#app",
  components: { App },
  render: h => h(App)
})
